module.exports = __webpack_public_path__ + "static/media/step3.15179091.png";